var $62f9bc1f98ea21de$exports = {};
$62f9bc1f98ea21de$exports = {
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Selecteer een item`,
    "tableResizer": `Resizer`,
    "colorSwatchPicker": `Color swatches`
};


export {$62f9bc1f98ea21de$exports as default};
//# sourceMappingURL=nl-NL.mjs.map
